import { Footer } from "../components/Footer"
import { PayoutAeropayMethods } from "../components/payout/PayoutAeropayMethods"


export const PayoutAeropayPage = () => {
    return (
        <div className="container">
            <PayoutAeropayMethods />
            <Footer />
        </div>
    );
}